import { render, staticRenderFns } from "./PurchaseOrderItems.vue?vue&type=template&id=59f42817&scoped=true&"
import script from "./PurchaseOrderItems.vue?vue&type=script&lang=js&"
export * from "./PurchaseOrderItems.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseOrderItems.vue?vue&type=style&index=0&id=59f42817&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f42817",
  null
  
)

export default component.exports